module.exports = __webpack_public_path__ + "img/天力保温杯2.36cd4b7c.jpg";